import { TranslationKeysMapper } from '@nimbus-library/features/localization/models/translation-keys.model';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';

export enum ThemeSetting {
  Browser = 'Browser',
  Light = 'Light',
  Dark = 'Dark',
}

export const ThemeSettingTranslateMap: TranslationKeysMapper<ThemeSetting> = {
  Browser: TranslationKeys.ThemeSettingBrowser,
  Light: TranslationKeys.ThemeSettingLight,
  Dark: TranslationKeys.ThemeSettingDark,
};
